if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // --- MULTI-COLOR QUICK ADD LOGIC ---
        let mixAndMatchInputs = document.querySelectorAll('.related-color-qty');
        let useJsonBody = false;
        let jsonBody = {};

        if (mixAndMatchInputs && mixAndMatchInputs.length > 0) {
          let itemsToAdd = [];
          let currentOptions = null;
          const mainVariantId = formData.get('id');

          const variantDataStrElement = document.querySelector(`variant-selects[data-section="${this.dataset.section}"] script[type="application/json"], variant-radios[data-section="${this.dataset.section}"] script[type="application/json"]`) || document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');

          if (variantDataStrElement) {
            try {
              const variants = JSON.parse(variantDataStrElement.textContent);
              const selectedVariant = variants.find(v => v.id.toString() === mainVariantId.toString());
              if (selectedVariant) {
                currentOptions = [selectedVariant.option1, selectedVariant.option2, selectedVariant.option3];
              }
            } catch (e) {
              console.error('Error parsing main variants', e);
            }
          }

          mixAndMatchInputs.forEach(input => {
            const qty = parseInt(input.value) || 0;
            const isMainProduct = input.getAttribute('data-product-id') === this.form.querySelector('[name="product-id"]')?.value;

            if (qty > 0) {
              let variantIdToAdd = null;
              try {
                let variantsStr = input.getAttribute('data-variants') || "[]";
                const siblingVariants = JSON.parse(variantsStr);

                if (currentOptions) {
                  const matchingVariant = siblingVariants.find(v =>
                    v.option1 === currentOptions[0] &&
                    v.option2 === currentOptions[1] &&
                    v.option3 === currentOptions[2]
                  );
                  if (matchingVariant) {
                    variantIdToAdd = matchingVariant.id;
                  }
                }

                // Fallback to the first available variant if options don't match exactly
                if (!variantIdToAdd && siblingVariants.length > 0) {
                  variantIdToAdd = siblingVariants[0].id;
                }
              } catch (e) {
                console.error('Error parsing sibling variants', e);
              }

              if (variantIdToAdd) {
                itemsToAdd.push({ id: variantIdToAdd, quantity: qty });
              }
            }
          });

          // Also check for the main product's standard quantity input if they didn't use swatches (fallback)
          if (itemsToAdd.length === 0) {
            const standardQty = parseInt(formData.get('quantity')) || 0;
            if (standardQty > 0) {
              itemsToAdd.push({ id: mainVariantId, quantity: standardQty });
            }
          }

          if (itemsToAdd.length > 1 || (itemsToAdd.length === 1 && itemsToAdd[0].id.toString() !== mainVariantId.toString()) || (itemsToAdd.length === 1 && itemsToAdd[0].quantity !== 1)) {
            useJsonBody = true;
            jsonBody = { items: itemsToAdd };

            if (this.cart) {
              jsonBody.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
              jsonBody.sections_url = window.location.pathname;
            }
          } else if (itemsToAdd.length === 0) {
            this.handleErrorMessage("Please select at least one quantity to add to cart.");
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            return; // Stop the request completely
          }
        }

        let requestUrl = routes.cart_add_url;

        if (useJsonBody) {
          // Re-create headers object completely to bypass potential Headers instantiation bugs
          config.headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          };
          config.body = JSON.stringify(jsonBody);
          if (!requestUrl.endsWith('.js')) {
            requestUrl = requestUrl + '.js';
          }
        } else {
          config.body = formData;
        }

        // --- END MULTI-COLOR QUICK ADD LOGIC ---

        fetch(requestUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
